import { fetchUtils } from 'react-admin'

const extractErrorMessage = error => {
  if (!error) return null
  const body = error.body || {}
  if (body.error && body.error.description) {
    return body.error.description
  }
  if (body.message) {
    return body.message
  }
  return null
}

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  const auth = JSON.parse(localStorage.getItem('auth'))
  if (auth) {
    options.headers.set('Authorization', `Basic ${auth.token}`)
  }

  return fetchUtils.fetchJson(url, options).catch(error => {
    const serverMessage = extractErrorMessage(error)
    if (serverMessage) {
      error.message = serverMessage
    }
    throw error
  })
}

export default httpClient
